import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Zap } from 'lucide-react';
export function EliteUpgrade() {
  return <section className="bg-white py-20 px-4" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <div className="text-center mb-16" data-id="element-71">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-[#0284C7] mb-4 uppercase tracking-wide" data-id="element-72">
            ¿Qué agrega el Megapack Élite?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 italic" data-id="element-73">
            Por solo $9.000 más, llevás tu entrenamiento al siguiente nivel.
          </motion.p>
        </div>

        <div className="space-y-8" data-id="element-74">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col md:flex-row items-start gap-6 bg-white p-8 rounded-2xl border border-[#0284C7]/20 shadow-sm hover:border-[#0284C7] transition-colors" data-id="element-75">
            <div className="bg-[#F97316]/10 p-4 rounded-full flex-shrink-0" data-id="element-76">
              <Trophy className="w-12 h-12 text-[#0284C7]" data-id="element-77" />
            </div>
            <div data-id="element-78">
              <h3 className="text-2xl font-bold text-[#0284C7] mb-4 uppercase" data-id="element-79">
                🏆 Élite 1 — Sistemas de Juego Olímpicos
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-80">
                La pizarra táctica de Países Bajos y Las Leonas adaptada a tu
                cancha del martes. El Falso Arriba, la Salida de 3 Élite, 5
                Trampas de Anticipación, análisis de video low-cost y 10
                variantes de CC que el rival nunca vio. Un sistema completo para
                pensar como entrenador de selección.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-col md:flex-row items-start gap-6 bg-white p-8 rounded-2xl border border-[#0284C7]/20 shadow-sm hover:border-[#0284C7] transition-colors" data-id="element-81">
            <div className="bg-[#F97316]/10 p-4 rounded-full flex-shrink-0" data-id="element-82">
              <Zap className="w-12 h-12 text-[#0284C7]" data-id="element-83" />
            </div>
            <div data-id="element-84">
              <h3 className="text-2xl font-bold text-[#0284C7] mb-4 uppercase" data-id="element-85">
                ⚡ Élite 2 — El Acelerador Técnico
              </h3>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-86">
                +100 variaciones de ejercicios para que tus clases nunca sean
                iguales ni aburridas. El ejercicio no funciona: variante de
                regla. Vinieron 8: protocolo de grupo chico. Hace 35°C: ajuste
                de clima. El grupo perdió energía: 5 Salvavidas en 15 minutos.
                Todo resuelto.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}